import Swal from 'sweetalert2';

export const swalMsg = (icon, title, text) => {
    Swal.fire({
        icon, title,
        text, timer: 4000
    });
};

export const valMsg = (icon, title, text) => {
    Swal.fire({
        icon, title, text
    });
};

export const basicMsg = (text) => {
    Swal.fire(text);
};

export const htmlMsg = (icon, title, html) => {
    Swal.fire({
        icon, title, html,
        confirmButtonText: 'Entendido',
    });
};

export const msgAndTimer = (text, icon) => {
    Swal.fire({ text, icon, timer: 1500 });
};

export const simpleConfirmDialog = async (title, confirmButtonText) => {
    return await Swal.fire({
        title,
        showDenyButton: true,
        confirmButtonText,
        denyButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed)
            return true;
        return false;
    });
};